import { AlulaResponseData } from "@app/shared/databases/alula.database";
import { ImportMap } from "@app/shared/resources/class-importer-exporter.service";

interface AlulaUserInt {
    id: string;
    username: string;
    password: string;
    firstName: string;
    lastName: string;
    email: string;
    dealerId: string;
    userType: number;
}

interface AlulaUserData {
    id: string;
    username: string;
    password: string;
    nameFirst: string;
    nameLast: string;
    email: string;
    dealerId: string;
    uType: number;
}

export class AlulaUser {
    static readonly importMap: ImportMap<AlulaUserInt, AlulaUserData> = [
        { i: "id", o: "id" },
        { i: "username", o: "username" },
        { i: "password", o: "password" },
        { i: "nameFirst", o: "firstName" },
        { i: "nameLast", o: "lastName" },
        { i: "email", o: "email" },
        { i: "dealerId", o: "dealerId" },
        { i: "uType", o: "userType" },
    ];

    static fromDbObject(alulaUser: AlulaResponseData): AlulaUser {
        if (alulaUser) {
            return new AlulaUser(
                alulaUser.id,
                alulaUser.attributes[AlulaUser.importMap[1].i],
                alulaUser.attributes[AlulaUser.importMap[2].i],
                alulaUser.attributes[AlulaUser.importMap[3].i],
                alulaUser.attributes[AlulaUser.importMap[4].i],
                alulaUser.attributes[AlulaUser.importMap[5].i],
                alulaUser.attributes[AlulaUser.importMap[6].i],
                alulaUser.attributes[AlulaUser.importMap[7].i]
            );
        }
            return null;

    }

    static generateUsername(macAddress: string) {
        return macAddress.replace(":", "") + "-" + Date.now();
    }

    static fromClareUser(clareUser, alulaDealerId: string): AlulaUser {
        return new AlulaUser(null, null, null, clareUser.firstName, clareUser.lastName, clareUser.email, alulaDealerId);
    }

    constructor(
        public id: string,
        public username: string,
        public password: string,
        public firstName: string,
        public lastName: string,
        public email: string,
        public dealerId: string,
        public userType: number = 32
    ) {}
}
